export default "__VITE_ASSET___eF5C7rT__"